// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__2hz05","label":"SetPasswdForm_label__iQxdi"};